export function toReadablePercent(percent: number) {
  return `${Math.round(percent)}%`
}

export function cn(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export function getCookie(request: Request, key: string, defaultValue: string) {
  return (
    request.headers
      .get('cookie')
      ?.split('; ')
      .find((row) => row.startsWith(`${key}=`))
      ?.split('=')[1] || defaultValue
  )
}

export function getFromLocalStorage(key: string, defaultValue: string) {
  if (typeof window === 'undefined') return defaultValue

  return localStorage.getItem(key) || defaultValue
}

export function setToLocalStorage(key: string, value: string) {
  if (typeof window === 'undefined') return

  localStorage.setItem(key, value)
}

export function validateOption(
  option: string,
  options: string[],
  defaultValue: string
) {
  return options.includes(option) ? option : defaultValue
}

export function removeTrailingSlashAtTheEnd(url: string) {
  return url.endsWith('/') ? url.slice(0, -1) : url
}
